import 'bootstrap/dist/js/bootstrap.min.js';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import 'bootstrap/dist/css/bootstrap.css';
import VueLazyload from 'vue-lazyload';

const app = createApp(App);
app.use(store);
app.use(router);
app.use(VueLazyload, {
	preLoad: 1.3,
	error: './assets/images/LOGO.png',
	loading: './assets/images/LOGO.png',
	attempt: 1
});
app.mount('#app');
